module.exports = __webpack_public_path__ + "static/media/tips.3a9841b6.mp3";